import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetInvalidLinks
};

function GetInvalidLinks(onSuccess, onError) {

    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/invalidlinks`, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}